import script from "./pure-display.vue?vue&type=script&lang=tsx"
export * from "./pure-display.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__